// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG) {
    case "ProductPickerModalCalled" :
      return {
        productPickerModalOpened: action._0,
        globalFeeModalOpened: state.globalFeeModalOpened,
        file: state.file,
        loadingState: state.loadingState
      };
    case "GlobalFeeModalCalled" :
      return {
        productPickerModalOpened: state.productPickerModalOpened,
        globalFeeModalOpened: action._0,
        file: state.file,
        loadingState: state.loadingState
      };
    case "FileImported" :
      return {
        productPickerModalOpened: state.productPickerModalOpened,
        globalFeeModalOpened: state.globalFeeModalOpened,
        file: {
          src: action._0,
          shopId: action._1
        },
        loadingState: state.loadingState
      };
    case "CartLoadingStateRequested" :
      return {
        productPickerModalOpened: state.productPickerModalOpened,
        globalFeeModalOpened: state.globalFeeModalOpened,
        file: state.file,
        loadingState: action._0
      };
  }
}

let initialState = {
  productPickerModalOpened: false,
  globalFeeModalOpened: false,
  file: undefined,
  loadingState: undefined
};

export {
  initialState,
  reducer,
}
/* No side effect */
